import { FC, useCallback, useRef } from 'react';

import ArrowDownIcon from '@z-components/static/images/icon-arrow-drop-down.svg';
import ArrowUpIcon from '@z-components/static/images/icon-arrow-drop-up.svg';

import styles from './Tab.module.scss';

interface Props {
  direction?: 'asc' | 'desc';
  isDisabled?: boolean;
  label?: string;
  onClick?: (offsetLeft?: number) => void;
  selected?: boolean;
  testId?: string;
}

const Tab: FC<Props> = ({
  direction,
  isDisabled = false,
  label = '',
  onClick = () => null,
  selected = false,
  testId,
}) => {
  const tabRef = useRef<HTMLButtonElement>(null);

  const handleClick = useCallback(() => {
    onClick(tabRef.current?.offsetLeft);
  }, [onClick]);

  return (
    <button
      ref={tabRef}
      data-test-id={testId}
      className={selected ? styles['z-tab-selected'] : styles['z-tab-unselected']}
      disabled={isDisabled}
      onClick={handleClick}
      type="button"
    >
      <span className={styles['z-tab-container']}>
        <span className={styles['z-tab-label']}>
          {selected && !direction ? <h2>{label}</h2> : label}
        </span>
        {direction && (
          <>
            {direction === 'asc' ? (
              <ArrowUpIcon
                className={selected ? styles['z-arrow-primary'] : styles['z-arrow-secondary']}
              />
            ) : (
              <ArrowDownIcon
                className={selected ? styles['z-arrow-primary'] : styles['z-arrow-secondary']}
              />
            )}
          </>
        )}
      </span>
    </button>
  );
};

export default Tab;
export type { Props as TabProps };
